
import "./App.css";
import { Route, Routes, BrowserRouter } from 'react-router-dom';
import { NavBar } from "./components/NavBar/NavBar";
import {Home} from "./components/Home/Home";
import { Contacto } from "./components/Contacto/Contacto";
import { Elegirnos } from "./components/Elegirnos/Elegirnos";
import { QuienesSomos } from "./components/QuienesSomos/QuienesSomos";
import { ItemListContainer } from "./components/ItemListContainer/ItemListContainer";
import { ItemDetailContainer } from "./components/ItemDetailContainer/ItemDetailContainer";
import { Footer } from "./components/Footer/Footer";
import { Cart } from "./components/Cart/Cart"
import { CartContextProvider } from "./Context/CartContext";

function App() {
  return (
    <>
    <CartContextProvider>

      <BrowserRouter>
      <header className="App-header">
        <NavBar />
      </header>
        <Routes>
          <Route path='/' element={<Home/>}/>
          <Route path='/Contacto' element={<Contacto />}/>
          <Route path='/Elegirnos' element={<Elegirnos/>}/>
          <Route path='/QuienesSomos' element={<QuienesSomos/>}/>
          <Route path='/Productos' element={<ItemListContainer />}/>
          <Route path='/Categoria/:categoryId' element={<ItemListContainer />}/>
          <Route path='/Productos/:productId' element={<ItemDetailContainer />}/>
          <Route path='/Cart' element={<Cart/>}/>
        </Routes>
        <footer>
          <Footer />
        </footer>
      </BrowserRouter>
    </CartContextProvider>
    </>
  );
}

export default App;
